/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Enumeration of network resources tracked by the NetworkAvailabilityService
 */
enum NetworkResource {
  /** At least one network interface (Ethernet, Wi-Fi, USB, Cellular) is up with a valid IP. */
  NETWORK_INTERFACE = "NETWORK_INTERFACE",

  /** The device can reach the external Internet (beyond the LAN router). */
  INTERNET = "INTERNET"
}

export { NetworkResource };
